export default "__VITE_ASSET__252bcf06__"